import React, { useEffect, useState } from "react";
import {
  Form, Input, DatePicker, TimePicker, Select, Mentions, Button, message,
  Checkbox, Radio, Modal, Table
} from 'antd';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat.js';
dayjs.extend(advancedFormat);
import getOffsetTime from '../../../../utils/getOffsetTime.js';
import timeZones from '../../utils/live-schedules/drop-down-tables/timeZones.js';
import AuthLogic from '../../../../AuthLogic/index.js';
import './forms.scss';

const { TextArea } = Input;
const { Option } = Select;

const datePickerFormat = 'h:mm a, MMM Do'
const durationFormat = 'HH:mm';
const FormItem = Form.Item;

const EditTourActivityFlagsForm = React.memo(({ loading, resource, itemDetails, user, confirmDialogue,
  tourActivityFlagsTableDataSource, tourActivityFlags, jobElementsByTour, tourActivityFlag,
  activityFlagByTour, ...props
}) => {
  const { itemType } = itemDetails;
  const { getFieldDecorator, getFieldsError, getFieldsValue } = props.form;
  const [selectedRowKeysArray, setSelectedRowKeysArray] = useState([0]);
  const [dirtyTableRows, setDirtyTableRows] = useState(false);

  const columns = [
    {
      title: 'Activity Flag',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Start Time',
      dataIndex: 'startTime',
      key: 'startTime',
    },
    {
      title: 'Duration',
      dataIndex: 'duration',
      key: 'duration',
    },
    {
      title: 'Assignment',
      dataIndex: 'jobNumber',
      key: 'jobNumber',
    }
  ];

  const handleSelectedRowChange = async (selectedRowKeys) => {
    setSelectedRowKeysArray(selectedRowKeys);
    await props.getTourActivityFlag(tourActivityFlags.data.find((elem) => elem.id === tourActivityFlagsTableDataSource[selectedRowKeys[0]].id).id);
    console.log(selectedRowKeys); // debug
  }

  const rowSelection = {
    selectedRowKeys: selectedRowKeysArray, // Table component's selectedRowKeys is always an array
    onChange: handleSelectedRowChange,
    type: 'radio',
    onSelect: async (record, selected) => {
      // console.log(selected);
      // console.log(record);
    }
  };

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 5,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    // collect all fields currently in error state
    for (const [field, error] of Object.entries(getFieldsError())) {
      if (error) {
        errors[`${field}`] = error;
      }
    }
    if (Object.values(errors).length === 0) {
      console.log('Success! Received values of form: ', getFieldsValue())
      if (tourActivityFlag) {
        props.updateTourActivityFlag();
      } else if (!tourActivityFlag) {
        props.createTourActivityFlag();
      }
    } else {
      invalidForm();
      console.log('Invalid Form! ', errors);
    }
  };

  useEffect(() => {
    itemDetails.itemType = 'tourActivityFlag';
    props.updateState({ itemDetails });
  }, []);

  useEffect(() => {
    if (!dirtyTableRows) {
      // set activity flag initially selected when tab opens
      let selectedTourActivityFlag = tourActivityFlags.data[0];
      itemDetails.selectedTourActivityFlagDetails = selectedTourActivityFlag;
      props.updateState({ itemDetails });
    }
    setDirtyTableRows(true);
  }), [];

  /**
   * populate fields on initial component mount
   * (getFieldDecorator overrides `value` on forms)
   */
  useEffect(() => {
    const form = props.form;
    form.setFieldsValue({
      tourActivityFlagStartTime: itemDetails.tourActivityFlagStartTime,
      tourActivityFlagDuration: itemDetails.tourActivityFlagDuration,
    });
  }, [itemDetails.tourActivityFlagStartTime, itemDetails.tourActivityFlagDuration, confirmDialogue, tourActivityFlag, selectedRowKeysArray]);

  // update fields from new activity flag selection
  useEffect(() => {
    if (itemDetails && tourActivityFlag && tourActivityFlag.data) {
      itemDetails.tourActivityFlagId = tourActivityFlag.data[0].id;
      itemDetails.activityFlagId = tourActivityFlag.data[0].activityFlagId;
      itemDetails.jobElementId = tourActivityFlag.data[0].jobElementId;

      // timezone offset adjustment
      let startTime = dayjs(tourActivityFlag.data[0].startTime);
      let endTime = dayjs(tourActivityFlag.data[0].endTime);
      let timeZoneOffset = getOffsetTime(startTime);
      let tourActivityFlagStartTime = startTime.add(timeZoneOffset, 'minute');
      let tourActivityFlagEndTime = endTime.add(timeZoneOffset, 'minute');

      // update starte/end time
      itemDetails.tourActivityFlagStartTime = tourActivityFlagStartTime;
      itemDetails.tourActivityFlagEndTime = tourActivityFlagEndTime;
      props.generateItemDuration('tourActivityFlag', tourActivityFlagStartTime, tourActivityFlagEndTime);

      itemDetails.selectedTourActivityFlagDetails = tourActivityFlag.data[0];

    } else if (itemDetails && !tourActivityFlag) {
      // clear fields for create new tourActivityFlag form
      itemDetails.activityFlagId = null;
      itemDetails.jobElementId = null;

      // timezone offset adjustment
      // let startTime = dayjs(itemDetails.tourStartTime);
      // let endTime = dayjs(itemDetails.tourStartTime);
      // let timeZoneOffset = getOffsetTime(startTime);
      // let tourActivityFlagStartTime = dayjs(startTime).subtract(timeZoneOffset, 'minute');
      // let tourActivityFlagEndTime = dayjs(tourActivityFlagStartTime).add(15, 'minute'); // initial default is 15 minutes

      // update start/end time

      // itemDetails.tourActivityFlagStartTime = tourActivityFlagStartTime;
      // itemDetails.tourActivityFlagEndTime = tourActivityFlagEndTime;
      // props.generateItemDuration('tourActivityFlag', tourActivityFlagStartTime, tourActivityFlagEndTime);

      itemDetails.tourActivityFlagStartTime = dayjs(itemDetails.tourStartTime);  // default + prevent having to adjust timezone again
      itemDetails.tourActivityFlagEndTime = dayjs(itemDetails.tourStartTime).add(1, 'hour');  // initial default
      props.generateItemDuration('tourActivityFlag', itemDetails.tourActivityFlagStartTime, itemDetails.tourActivityFlagEndTime);
    }

    props.updateState({ itemDetails });

  }, [itemDetails, tourActivityFlag, selectedRowKeysArray])


  const switchToNewFlagForm = async () => {
    tourActivityFlag = null;
    props.updateState({ tourActivityFlag });
    setSelectedRowKeysArray(null); // un-select anything in table
  }

  if (itemDetails && !loading
  ) {
    // console.log(`selectedRowKeysArray: ${selectedRowKeysArray}`) // debug
    console.log(`dirtyTableRows: ${dirtyTableRows}`);
    return (

      <Form onSubmit={handleSubmit}>

        <FormItem>
          <Table
            dataSource={tourActivityFlagsTableDataSource}
            columns={columns}
            rowSelection={rowSelection}
          // rowClassName={(record) =>  record.color ? record.color.replace('#', '') : null}
          // onRow={(record) => record.key === selectedRowKeysArray[0] ? record.color = 'greenRow' : null}
          // ßrowClassName={(record) => ''}
          />
        </FormItem>

        <FormItem
          label="Start Time"
          style={{ display: "flex", marginBottom: 5 }}
        >
          {getFieldDecorator('tourActivityFlagStartTime', {
            rules: [{
              required: true, message: 'Please input start time!',
            }],
          })(
            <DatePicker
              name="tourActivityFlagStartTime"
              showTime={{ format: datePickerFormat, use12Hours: true, minuteStep: 15 }}
              onChange={props.handleItemStartTimeChange}
              placeholder={'Select date and time'}
              format={datePickerFormat}
              allowClear={false}
              size={'large'}
              styles={{
                popup: {
                  root: {
                    zIndex: 2000
                  }
                }
              }}
            />
          )}
        </FormItem>

        <FormItem
          label="Duration"
          style={{ display: "flex", marginBottom: 5 }}
        >
          {itemDetails.tourActivityFlagDuration && itemDetails.tourActivityFlagDurationDays && itemDetails.tourActivityFlagDurationDays.days &&
            (
              <span>
                <Mentions
                  value={itemDetails.tourActivityFlagDurationDays.days}
                  readOnly
                  style={{ marginLeft: 10, marginRight: 5, width: 50 }}
                />
                <span>day(s) &</span>
              </span>
            )
          }
          {getFieldDecorator('tourActivityFlagDuration', {
            rules: [{
              required: true, message: 'Duration is required!',
              type: 'object'
            }],
          })(
            <TimePicker
              name="tourActivityFlagDuration"
              onChange={props.handleItemDurationChange}
              allowClear={false}
              format={durationFormat}
              minuteStep={15}
              style={{ marginLeft: 5, marginRight: 5 }}
              showNow={false}
            />
          )}
          hours
        </FormItem>


        <FormItem
          label={<span><span id="asterisk">* </span><span>Activity Flag</span></span>}
          style={{ display: "flex", marginBottom: 5 }}
        >
          <Select
            name="activityFlagId"
            value={`activityFlagId-${itemDetails.activityFlagId ? itemDetails.activityFlagId.toString() : -1}`}
            onChange={props.handleOmnibusFieldChange}
            style={{ width: 230 }}
          >
            <Option key={null} value={`activityFlagId-${-1}`}>&nbsp;</Option>

            {activityFlagByTour &&
              activityFlagByTour.data.map((elem) => {
                return <Option key={elem.id} value={`activityFlagId-${elem.id}`}>{elem.name}</Option>
              })}
          </Select>
        </FormItem>

        <FormItem
          label={'Assignment'}
          style={{ display: "flex", marginBottom: 5 }}
        >
          <Select
            name="jobElementId"
            value={`jobElementId-${itemDetails.jobElementId ? itemDetails.jobElementId.toString() : 0}`}
            onChange={props.handleOmnibusFieldChange}
            style={{ width: 300 }}
          >
            <Option key={null} value={`jobElementId-${0}`}>&nbsp;</Option>

            {jobElementsByTour &&
              jobElementsByTour.data.map((elem) => {
                return <Option key={elem.id} value={`jobElementId-${elem.id}`}>
                  {`${elem.jobNumber}/${elem.startActual.split('T')[1].slice(0, 5)}-${elem.endActual.split('T')[1].slice(0, 5)}/${elem.service}`}
                </Option>
              })}
          </Select>
        </FormItem>

        <FormItem
          style={{ marginTop: 20 }}
        >
          {tourActivityFlag &&
            (
              <React.Fragment>
                <Button type="primary" ghost size={'large'} htmlType="submit">
                  Update
                </Button>
                <Button type="danger" ghost size={'large'} onClick={() => props.handleItemDelete('tourActivityFlag')} >
                  Delete
                </Button>
                <Button type="default" size={'large'} onClick={() => switchToNewFlagForm()} >
                  New
                </Button>
              </React.Fragment>
            )
          }
          {!tourActivityFlag &&
            <Button type="default" size={'large'} htmlType="submit">
              Save
            </Button>
          }
        </FormItem>

      </Form>
    );
  } else return 'loading...'
})

export default EditTourActivityFlagsForm;

